var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "externalEmailChanged" } }, [
    _c(
      "div",
      { staticClass: "vo-external-card" },
      [
        _c("vo-external-header", { attrs: { title: _vm.title } }),
        _vm._v(" "),
        _c("div", { staticClass: "vo-body" }, [
          _c("div", { staticClass: "vo-title" }, [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _c("div", { staticClass: "vo-context" }, [
            _vm._v("Please wait while we verify your email address.")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _vm.lockout
                ? _c("v-progress-circular", {
                    staticStyle: { margin: "8px auto", width: "40px" },
                    attrs: { indeterminate: "", color: "primary", size: 40 }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c848a81", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c848a81","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalChangeEmail.vue
// module id = 651
// module chunks = 4